import React, { useState } from 'react';
import { IconButton, Input, InputAdornment } from '@mui/material';
import CopyToClipboard from 'react-copy-to-clipboard';
import { FaCheck, FaCopy } from 'react-icons/fa';

function ClipboardCopy({ copyText, customStyles }) {
  const [isCopied, setIsCopied] = useState(false);

  // onClick handler function for the copy button
  const handleCopyClick = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2500);
  };

  return (
    <div style={customStyles}>
      <Input
        type="text"
        className="form-control"
        value={copyText}
        sx={{ height: '42px' }}
        endAdornment={(
          <InputAdornment position="end">
            <IconButton
              onClick={handleCopyClick}
              sx={{
                borderRadius: '0', borderLeft: '1px solid #cbcbcb', fontSize: '20px', padding: '0px', paddingLeft: '10px', color: 'black'
              }}
            >
              <CopyToClipboard text={copyText} onCopy={handleCopyClick}>
                {isCopied ? <FaCheck /> : <FaCopy />}
              </CopyToClipboard>
            </IconButton>
          </InputAdornment>
        )}
        disableUnderline="true"
      />
    </div>
  );
}

export default ClipboardCopy;
